import { Helmet } from 'react-helmet-async';
import ActivationsCampaign from 'src/sections/overview/dashboards/views/activations/campaign/campaign';

export default function BrandShieldCampaigns() {
  return (
    <>
      <Helmet>
        <title>Campaigns</title>
      </Helmet>

      <ActivationsCampaign />
    </>
  );
}
